import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import moment from 'moment';
import { PATHS } from 'src/common/constants';
import AssetDocuments from './AssetDocuments';
import AssetNotes from './AssetNotes';
import AssetMaintenance from './AssetMaintenanceGuide';
import Breadcrumb from '../../components/Breadcrumb';
import HeadingWithDetails from '../../components/HeadingWithDetails';
import FontAwesomeIcon from '../../components/Icon';
import Metrics from '../../components/Metrics';
import Tabs from '../../components/Tabs';
import WithNavigation from '../../layouts/WithNavigation';
import Card from '../../components/Card';
import Label from '../../components/Label/Label';
import Button from '../../components/Button';
import Loader from '../../components/Loader';
import {
  fetchFaqsNotesDocuments,
  clearFaqsNotesDocuments,
  clearNotes,
} from 'src/store/actions/faqsNotesDocuments';
import {
  selectDocuments,
  selectMaintenanceGuides,
  selectFaqs,
} from 'src/store/selectors/faqsNotesDocuments';

import { updateAsset, deleteAsset } from 'src/store/actions/assets';
import {
  setAssetFormData,
  clearAssetFormData,
} from 'src/store/actions/assetForm';
import Overlay from '../../components/Overlay';
import AssetForm from '../../components/AssetForm';
import { selectAuthenticatedUser } from 'src/store/selectors/auth';
import AssetFaqs from './AssetFaqs';
import {
  selectAssetByAreaAndAssetId,
  selectAreaById,
} from 'src/store/selectors/assets';
import { variables } from 'src/Tenants';
import ItemSpecifications from '../Item/ItemSpecifications';
import { selectSpecifications } from 'src/store/selectors/Specifications';
import * as client from '../../services/client';
import { clearFndFormData } from 'src/store/actions/fndForm';
import {
  AssetNotesProvider,
  useAssetNotesActionsFromContext,
  useAssetNotesDataFromContext,
} from './Context/AssetNotesContext';

const AssetInner = (props: any) => {
  const [showOverlay, setShowOverlay] = useState(false);
  const [specificItem, setSpecificItem] = useState([]);
  const [loader, setLoader] = useState(false);

  const assetId = props.match.params.id.split('&');

  const area = useSelector((state: any) => selectAreaById(state, assetId[0]));
  const asset = useSelector((state: any) =>
    selectAssetByAreaAndAssetId(state, assetId[0], assetId[1])
  );
  const documents = useSelector(selectDocuments);
  const maintenance = useSelector(selectMaintenanceGuides);
  const faqs = useSelector(selectFaqs);
  const user = useSelector(selectAuthenticatedUser);
  const specificationsList = useSelector(selectSpecifications);
  const notesList = useSelector((state: any) => state.notes);

  const { notes } = useAssetNotesDataFromContext();
  const { fetchNotes } = useAssetNotesActionsFromContext();

  const dispatch = useDispatch();

  const { suite, property } = props.location.state;
  const activeTab = props.location?.state?.activeTab || 0;

  useEffect(() => {
    const initializeComponent = async () => {
      dispatch(clearFndFormData());
      dispatch(clearNotes());
      dispatch(clearFaqsNotesDocuments());

      if (asset?.id) {
        dispatch(fetchFaqsNotesDocuments(asset.id, 'itemdata'));
        await fetchNotes(asset.id);
      }

      if (asset?.item?.id) {
        try {
          setLoader(true);
          const response: any = await client.fetchSpecifications(asset.item.id);

          if (response.status === 200) {
            const responsejson = await response.json();

            if (responsejson.statusCode === 200) {
              setSpecificItem(responsejson.data);
            } else {
              setSpecificItem([]);
            }
          } else {
            setSpecificItem([]);
          }
        } catch (error) {
          console.error('Error fetching specifications:', error);
          setSpecificItem([]);
        } finally {
          setLoader(false);
        }
      }
    };

    initializeComponent();
  }, []);

  const onSaveAsset = (asset: any) => {
    let params: any = {};

    if (asset.id) {
      params = {
        id: asset.id,
        Name: asset.item.name,
        unitId: suite.id,
        AreaId: asset.areaId,
        ItemId: asset.itemId ? asset.itemId : asset.item.id,
        RoomType: asset.roomType,
        UserId: user.id,
        DateOfPurchase: asset.dateOfPurchase
          ? new Date(moment(asset.dateOfPurchase).format('l LT'))
          : new Date(moment().format('MM-DD-YYYY')),
        VendorId: asset && asset.vendorId ? asset.vendorId : null,
        VendorName: asset && asset.vendorId ? asset.vendorName : '',
      };
      if (!asset.vendorId) {
        delete params.VendorId;
        delete params.VendorName;
      }
      dispatch(updateAsset(params, props.history, suite, property));
    }
  };

  const onDeleteAsset = (assetId: any) => {
    dispatch(
      deleteAsset(area.id, assetId, props.history, suite, property, user.id)
    );
  };

  // Process notes visibility logic
  let HmeOwnrOcpntRltrNotes = [];
  let noteVisibleToHomeownerOccupantRealtor = false;

  if (notesList && Array.isArray(notesList) && notesList.length > 0) {
    let notesFiltered = notesList.filter((x: any) => x.type === 'NOTES');
    if (notesFiltered.length > 0) {
      notesFiltered.forEach((object: any) => {
        HmeOwnrOcpntRltrNotes.push(
          JSON.parse(JSON.parse(JSON.stringify(object.data)))
        );
      });
    }
    if (HmeOwnrOcpntRltrNotes.length > 0) {
      let filterNotes = HmeOwnrOcpntRltrNotes.filter(
        (x: any) => x.noteVisibleToHomeownerOccupantRealtor === true
      );
      if (filterNotes.length > 0) {
        noteVisibleToHomeownerOccupantRealtor = true;
      }
    }
  }

  const homeOwnerCheck =
    user &&
    user.roles &&
    user.roles.length > 0 &&
    (user.roles[0].role.name === 'Home Owner' ||
      user.roles[0].role.name === 'Realtor' ||
      user.roles[0].role.name === 'Occupant');

  const noSpecificationTabs = [
    {
      label: 'Manuals & Documents',
      count: documents.length.toString(),
      content: <AssetDocuments asset={asset} />,
    },
    {
      label: 'Maintenance Reminders',
      count: maintenance.length.toString(),
      content: <AssetMaintenance asset={asset} />,
    },
    {
      label: 'FAQs',
      count: faqs.length.toString(),
      content: <AssetFaqs asset={asset} />,
    },
    homeOwnerCheck && noteVisibleToHomeownerOccupantRealtor === false
      ? {}
      : {
          label: 'Notes',
          count: notes?.length?.toString() || '0',
          content: <AssetNotes asset={asset} />,
        },
  ];

  const withSpecificationTabs = [
    {
      label: 'Specifications',
      count: specificationsList.length.toString(),
      content: <ItemSpecifications item={asset.item} />,
    },
    {
      label: 'Manuals & Documents',
      count: documents.length.toString(),
      content: <AssetDocuments asset={asset} />,
    },
    {
      label: 'Maintenance Reminders',
      count: maintenance.length.toString(),
      content: <AssetMaintenance asset={asset} />,
    },
    {
      label: 'FAQs',
      count: faqs.length.toString(),
      content: <AssetFaqs asset={asset} />,
    },
    homeOwnerCheck && noteVisibleToHomeownerOccupantRealtor === false
      ? {}
      : {
          label: 'Notes',
          count: notes?.length?.toString() || '0',
          content: <AssetNotes asset={asset} />,
        },
  ];

  if (asset) {
    return (
      <WithNavigation
        title={asset.item && asset.item.name}
        top={
          <HeadingWithDetails
            style={{
              backgroundImage: 'url(/assets/banner-property.png)',
            }}
            breadcrumb={
              <Breadcrumb
                to={{
                  pathname: PATHS.SUITES_VIEW.replace(
                    ':id',
                    property.id + '&' + suite.id
                  ),
                  state: {
                    suite: suite,
                    property: property,
                    onNavigationBack: true,
                  },
                }}
                label={variables.Suite + ' ' + suite.number}
              />
            }
            headline={asset.item && asset.item.name}
            items={[
              <Card
                body={
                  <>
                    MAKE:{' '}
                    {asset.item && asset.item.makeName
                      ? asset.item.makeName
                      : '—'}{' '}
                    <br />
                    MODEL:{' '}
                    {asset.item && asset.item.model
                      ? asset.item.model
                      : '—'}{' '}
                    <br />
                    INSTALLED ON:{' '}
                    {asset.dateOfPurchase && asset.dateOfPurchase
                      ? moment(asset.dateOfPurchase).format('MM/DD/YYYY')
                      : ''}
                  </>
                }
              />,
              <Metrics
                items={[
                  {
                    key: 'Active',
                    value: asset.serviceActive,
                  },
                  {
                    key: 'Archived',
                    value: asset.serviceArchived,
                  },
                ]}
                title={null}
              />,
              <Card
                title="Warranty Expiration"
                body={
                  <Label
                    color={
                      asset.warrantDays < 30
                        ? 'red'
                        : asset.warrantDays < 60
                          ? 'yellow'
                          : 'teal'
                    }
                    label={
                      asset.warrantExpiration && asset.warrantExpiration
                        ? moment(asset.warrantExpiration).format('MM/DD/YYYY')
                        : ''
                    }
                  />
                }
              />,
              <Card
                title="Type/Room"
                body={
                  <>
                    {asset.item && asset.item.typeName
                      ? asset.item.typeName
                      : ''}
                    /{area.customLabel ? area.customLabel : area.name}
                  </>
                }
              />,
            ]}
            actions={
              homeOwnerCheck ? null : (
                <>
                  <Button
                    color="semantic"
                    onClick={() => {
                      setShowOverlay(true);
                      dispatch(
                        setAssetFormData({
                          ...asset,
                          areaId: area.areaId,
                          assetWarrantyDefaultStartDate:
                            suite.assetWarrantyDefaultStartDate,
                        })
                      );
                    }}
                    label={<FontAwesomeIcon glyph="pencil" weight="light" />}
                  />
                  <Button
                    color="semantic"
                    onClick={() =>
                      window.confirm(
                        `Are you sure you want to delete ${asset.item.name}?`
                      ) && onDeleteAsset(asset.id)
                    }
                    label={<FontAwesomeIcon glyph="trash" weight="light" />}
                  />
                  <Overlay
                    showOverlay={showOverlay}
                    content={
                      <AssetForm
                        propertyId={property.id}
                        onClose={() => {
                          setShowOverlay(false);
                          dispatch(clearAssetFormData());
                        }}
                        onSaveAsset={(data: any) => onSaveAsset(data)}
                      />
                    }
                  />
                </>
              )
            }
          />
        }
        bottom={
          <Tabs
            activeTab={activeTab}
            items={
              (user.roles[0].role.name === 'Home Owner' ||
                user.roles[0].role.name === 'Realtor') &&
              specificItem.length === 0
                ? noSpecificationTabs
                : withSpecificationTabs
            }
          />
        }
      />
    );
  }

  return <Loader />;
};

const Asset = (props: any) => {
  return (
    <AssetNotesProvider>
      <AssetInner {...props} />
    </AssetNotesProvider>
  );
};

export default Asset;
